import { createFeature, createReducer, on } from '@ngrx/store';

import { Employee } from 'app/shared/features/employee-selector/models';

import { updateEmployees } from './employee.actions';

export const employeeFeatureKey = 'employee';

export interface EmployeeState {
    employeeList: Employee[];
}

export const initialState: EmployeeState = { employeeList: [] };

export const reducer = createReducer(
    initialState,
    on(updateEmployees, (state, { employeeList }) => {
        // Actions of type 'loadEmployeesSuccess' are dispatched by master-data.service on a regular basis.
        // Here we check if the content for employee list has changed. If not then the state does not change.
        // Otherwise, components consuming employee list from the state will detect changes, and they will refresh
        // while it is not necessary. It will lead to unpredicted side effect. For example, the components
        // representing the employee list will be destroyed and recreated again on every change of the state.
        const currentJson = JSON.stringify(sortEmployees(state.employeeList));
        const newJson = JSON.stringify(sortEmployees(employeeList));
        const listChanged = currentJson !== newJson;
        return listChanged
            ? {
                  ...state,
                  employeeList: [...employeeList],
              }
            : state;
    }),
);

export const employeeFeature = createFeature({
    name: employeeFeatureKey,
    reducer,
});

function sortEmployees(list: Employee[]) {
    return [...list].sort((a, b) => a.number - b.number);
}
